import React from 'react';
import { NavLinkView } from './NavLink.view';
import useIsMobile from '../../../../helpers/responsive/useIsMobile';
import { useDispatch } from 'react-redux';
import { closeNavBar } from '../../../../store/actions';
import { useLocation } from 'react-router-dom';
import { NavLinkViewProps } from './NavLink.view';

export const NavLink = ({
  linkName,
  icon,
  link,
  isExternal,
  isOnBottomMenu,
  isOnBurgerMenu
}: Omit<NavLinkViewProps, 'handleClick' | 'isActiveLink'>) => {
  const isMobile = useIsMobile();
  const dispatch = useDispatch();
  const location = useLocation();

  const handleClick = () => {
    isMobile && dispatch(closeNavBar);
  };
  return (
    <NavLinkView
      isActiveLink={!isOnBurgerMenu && location.pathname === link}
      link={link}
      linkName={linkName}
      isExternal={isExternal}
      handleClick={handleClick}
      icon={icon}
      isOnBottomMenu={isOnBottomMenu}
      isOnBurgerMenu={isOnBurgerMenu}
    />
  );
};
